export default __webpack_public_path__ + "static/media/wheel.ef26760d.png";